import React from 'react';

/**
 * MmcArcadeCabinet
 * A lightweight wrapper that provides CRT effects without bulky borders.
 */
const MmcArcadeCabinet = ({ children, title, gameId, fullScreen = true }) => {
    return (
        <div className="mmc-cabinet">
            {/* The Screen */}
            <div className="mmc-cabinet__screen">
                <div className="mmc-cabinet__scanlines"></div>
                <div className="mmc-cabinet__crt-flicker"></div>
                <div className="mmc-cabinet__content">
                    {children}
                </div>
            </div>

            <style>{`
                .mmc-cabinet {
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    background: #000;
                    overflow: hidden;
                    position: relative;
                }

                .mmc-cabinet__screen {
                    position: relative;
                    flex: 1;
                    background: #0a0a0b;
                    overflow: hidden;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                }

                .mmc-cabinet__scanlines {
                    position: absolute;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: linear-gradient(
                        rgba(18, 16, 16, 0) 50%,
                        rgba(0, 0, 0, 0.05) 50%
                    );
                    background-size: 100% 4px;
                    z-index: 10;
                    pointer-events: none;
                    opacity: 0.5;
                }

                .mmc-cabinet__crt-flicker {
                    position: absolute;
                    top: 0; left: 0; right: 0; bottom: 0;
                    background: rgba(255, 255, 255, 0.01);
                    opacity: 0;
                    z-index: 11;
                    pointer-events: none;
                    animation: flicker 0.15s infinite;
                }

                @keyframes flicker {
                    0% { opacity: 0.005; }
                    50% { opacity: 0.012; }
                    100% { opacity: 0.005; }
                }

                /* Quantum CRT Vignette & Glow */
                .mmc-cabinet__screen::after {
                    content: "";
                    position: absolute;
                    inset: 0;
                    box-shadow: inset 0 0 120px rgba(0,0,0,0.7), inset 0 0 40px rgba(0,0,0,0.9);
                    pointer-events: none;
                    z-index: 12;
                }

                .mmc-cabinet__content {
                    position: relative;
                    z-index: 1;
                    width: 100%;
                    height: 100%;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    filter: brightness(1.1) contrast(1.1);
                }
            `}</style>
        </div>
    );
};

export default MmcArcadeCabinet;
